import { render, staticRenderFns } from "./tabs-mo-kuai.vue?vue&type=template&id=7d1a4b87&scoped=true"
import script from "./tabs-mo-kuai.vue?vue&type=script&lang=js"
export * from "./tabs-mo-kuai.vue?vue&type=script&lang=js"
import style0 from "./tabs-mo-kuai.vue?vue&type=style&index=0&id=7d1a4b87&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1a4b87",
  null
  
)

export default component.exports